<template>
  <div class="embed-responsive">
    <span
      class="d-block"
      :style="ratioStyle"
    />
    <slot
      name="item"
      v-bind="{ itemClass }"
    />
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';

export interface AspectRatio {
  /**
   * horizontal
   */
  h: number;
  /**
   * vertical
   */
  v: number;
}

export default Vue.extend({
  props: {
    ratio: {
      type: Object as PropType<AspectRatio>,
      default: (): AspectRatio => ({ h: 16, v: 9 }),
    },
  },

  computed: {
    ratioStyle(): Record<string, string> {
      const { v, h } = this.ratio;
      return {
        paddingTop: `${100 * v / h}%`,
      };
    },

    itemClass(): string {
      return 'embed-responsive-item';
    },
  },
});
</script>
